import { StateCreator } from 'zustand';
import { Middleware } from './common';
import { DashboardStoreState } from './DashboardProvider';
import { PanelGroupId } from './panel-group-slice';

export interface CleanUpLayoutSlice {
  isCleanUpLayoutDrawerOpen: boolean;
  cleanUpLayoutPanelGroupId: PanelGroupId | undefined;
  openCleanUpLayout: (panelGroupId: PanelGroupId) => void;
  closeCleanUpLayout: () => void;
}

export const createCleanUpLayoutSlice: StateCreator<
  CleanUpLayoutSlice & DashboardStoreState,
  Middleware,
  [],
  CleanUpLayoutSlice
> = (set) => ({
  isCleanUpLayoutDrawerOpen: false,
  cleanUpLayoutPanelGroupId: undefined,

  openCleanUpLayout(panelGroupId) {
    set(
      (state) => {
        state.isCleanUpLayoutDrawerOpen = true;
        state.cleanUpLayoutPanelGroupId = panelGroupId;
      },
      false,
      '[CleanUpLayout] openCleanUpLayout'
    );
  },

  closeCleanUpLayout() {
    set(
      (state) => {
        state.isCleanUpLayoutDrawerOpen = false;
        state.cleanUpLayoutPanelGroupId = undefined;
      },
      false,
      '[CleanUpLayout] closeCleanUpLayout'
    );
  },
});
